import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { isNullOrUndefined } from "@utils/object-util";

type GetVerificationUrlRequestResponse = {
    url: string;
};

export const getVerificationUrlRequest = async (
    rpServiceId: string,
    selectedIdp: string,
    selectedCountry: string,
    selectedRedirectTo: string,
    credential: string,
    asi: string,
    appId: string,
    attributeTypeToFieldValueMap: { [id: string]: { [id: string]: string } },
    canModifySelfServiceVerificationExpiration: boolean,
    loginHintExpirationType: string,
    loginHintExpirationValue: string
): Promise<GenericNetworkResponse<GetVerificationUrlRequestResponse>> => {
    const route = apiRoutes.serviceConfiguration.selfService.verification;

    const attributeTypeFieldValues: { [id: string]: string } = {};
    Object.values(attributeTypeToFieldValueMap).forEach(attributeFieldValueMap => {
        Object.entries(attributeFieldValueMap).forEach(([key, value]) => {
            attributeTypeFieldValues[key] = value;
        });
    });

    const additionalBody = (!(isNullOrUndefined(loginHintExpirationValue) || loginHintExpirationValue === "") && canModifySelfServiceVerificationExpiration)
        ? { expiration: { type: loginHintExpirationType, value: loginHintExpirationValue } }
        : {};

    const body = {
        appID: appId,
        attributes: attributeTypeFieldValues,
        IDP: selectedIdp,
        country: selectedCountry,
        callbackURL: selectedRedirectTo,
        credential: credential,
        asi: asi,
        rpServiceID: rpServiceId,
        ...additionalBody
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};